import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }                 from '../../app-lite/shared/shared.module';
import { TableModule }                  from '../table/table.module';
import { VendorActionsComponent }       from './vendor.actions.component';
import { VendorActivityLogsComponent }  from './vendor.activity-logs.component';
import { VendorChangeComponent }         from './vendor-change.component';
import { VendorComponent }              from './vendor.component';
import { VendorLinkedVendorsComponent }  from './vendor-linked-vendors.component';
import { VendorManuallyLinkComponent }   from './vendor-manually-link.component';
import { VendorQuickAddComponent }       from './vendor.quick-add.component';
import { VendorResolveMatchesComponent } from './vendor-resolve-matches.component';
import { VendorSearchControlComponent }  from './vendor.search-control.component';
import { VendorSearchService }           from './vendor.search.service';
import { VendorsListComponent }         from './vendors.list.component';

@NgModule({
  declarations: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorChangeComponent,
    VendorComponent,
    VendorLinkedVendorsComponent,
    VendorManuallyLinkComponent,
    VendorQuickAddComponent,
    VendorResolveMatchesComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  entryComponents: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorChangeComponent,
    VendorComponent,
    VendorLinkedVendorsComponent,
    VendorManuallyLinkComponent,
    VendorQuickAddComponent,
    VendorResolveMatchesComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  exports: [
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    VendorSearchService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class VendorsModule {}